"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvertableSelectItem = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var util_1 = require("@gooddata/util");
/**
 * @internal
 */
function InvertableSelectItem(props) {
    var _a;
    var title = props.title, onClick = props.onClick, onMouseOver = props.onMouseOver, onMouseOut = props.onMouseOut, isSelected = props.isSelected, onOnly = props.onOnly;
    var handleOnly = react_1.useCallback(function (e) {
        e.stopPropagation();
        onOnly === null || onOnly === void 0 ? void 0 : onOnly();
    }, [onOnly]);
    return (react_1.default.createElement("div", { className: classnames_1.default((_a = {
                "gd-list-item": true
            },
            _a["s-" + util_1.stringUtils.simplifyText(title)] = true,
            _a["has-only-visible"] = true,
            _a["is-selected"] = isSelected,
            _a)), onClick: onClick, onMouseOver: onMouseOver, onMouseOut: onMouseOut },
        react_1.default.createElement("label", { className: "input-checkbox-label" },
            react_1.default.createElement("input", { type: "checkbox", className: "input-checkbox", readOnly: true, checked: isSelected }),
            react_1.default.createElement("span", { className: "input-label-text" }, title)),
        react_1.default.createElement("span", { className: "gd-list-item-only", onClick: handleOnly },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "gs.list.only" }))));
}
exports.InvertableSelectItem = InvertableSelectItem;
//# sourceMappingURL=InvertableSelectItem.js.map